const _global = (typeof window !== 'undefined' ? window : typeof global !== 'undefined' ? global : typeof self !== 'undefined' ? self : {}); _global.SENTRY_RELEASE={id:"f4815a531cb84c54aadc50b2e6639b806a7829da"};
      _global.SENTRY_RELEASES=_global.SENTRY_RELEASES || {};
      _global.SENTRY_RELEASES["next@themecloud-o0"]={id:"f4815a531cb84c54aadc50b2e6639b806a7829da"};
      